import React from 'react';
import {useTranslation} from 'react-i18next';
import './EditModal.scss';

function EditModal({
  isOpen,
  title,
  value,
  onChange,
  onCancel,
  onSave,
  onDelete,
  showDelete = false,
  placeholder,
  isReadOnly = false,
  exitTapOnBackground = false,
}) {

  const {t} = useTranslation();


  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (exitTapOnBackground && e.target === e.currentTarget) {
      onCancel?.();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true">
      <div className="modal-content">
        <div className="modal-content-header">
          <div className="modal-content-header-left">
            <h3 className="modal-content-header-left-title">{title}</h3>
          </div>
          <div className="modal-content-header-right">
            {showDelete && (
              <div className="delete-idea-btn" onClick={onDelete}>
                <img src={'/assets/icons/icon_30_bin.png'} alt="delete" />
              </div>
            )}
          </div>
        </div>

        {isReadOnly ? (
          <div className="modal-readonly-text">{value}</div>
        ) : (
          <textarea value={value} onChange={(e) => onChange?.(e.target.value)} placeholder={placeholder} rows={4} />
        )}
        <div className="modal-buttons">
          <button onClick={onCancel} className="cancel-btn">
            {/* Localized by caller */}
            {t('general.cancel')}
          </button>
          {!isReadOnly && (
            <button onClick={onSave} className="save-btn">
              {/* Localized by caller */}
              {t('general.save')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default EditModal;


